[contenteditable="true"]:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
  color: #ccc;
}
textarea:focus,
input:focus {
  outline-color: #0066ff;
}
